export default class Video {
	static initAll() {
		const videos = document.querySelectorAll("video");

		videos.forEach((video) => new Video(video));
	}

	constructor(element) {
		this.element = element;
		this.started = false;
		this.controlsDefault = this.element instanceof HTMLVideoElement && this.element.controls;

		this.registerCallbacks();
	}

	registerCallbacks() {
		if (!(this.element instanceof HTMLVideoElement)) return;

		this.element.addEventListener("stalled", () => {
			if (!this.started) this.element.controls = true;
		});

		this.element.addEventListener("play", () => {
			this.started = true;
			if (!this.controlsDefault) this.element.controls = false;
		});
	}
}
